import { Box, Typography, useTheme } from '@mui/material';

const TierIcon = ({ tier, styles, customText = 'Tier ', fontSize = 16, height = '20px' }) => {
    const theme = useTheme();
    // Define los colores para cada tier
    // regex ex to get number from string
    const getTierNumber = (tier) => {
        if (!tier) return null;

        const regex = /\d+/;
        const number = isNaN(tier) ? tier.match(regex)[0] : tier;

        return number;
    };

    const tierNumber = getTierNumber(tier);

    const colors = {
        t1: '#1D6FB1 ', // Color para T1
        t2: '#00793d', // Color para T2
        t3: '#103b17', // Color para T3
        t4: '#ccc', // Color para T4
        t5: '#d15b00', // Color para T5
        t6: '#d32f2f', // Color para T6
    };

    const textColors = {
        t1: '#fff', // Color para T1
        t2: '#fff', // Color para T2
        t3: '#fff', // Color para T3
        t4: '#000', // Color para T4
        t5: '#fff', // Color para T5
        t6: '#fff', // Color para T6
    };

    // Define el color basado en el tier
    const backgroundColor = tierNumber > 0 && tierNumber <= 6 ? colors[`t${tierNumber}`] : '#f9f9f9';
    const color = tierNumber > 0 && tierNumber <= 6 ? textColors[`t${tierNumber}`] : '#000';
    const text = tierNumber > 0 && tierNumber <= 6 ? `${customText}${tierNumber}` : '-';

    return (
        <Box
            sx={{
                backgroundColor,
                color: color,
                width: '100%',
                height: height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                border: `1px solid ${theme.palette.border.dark}`,
                ...styles,
            }}
        >
            <Typography fontSize={fontSize} variant="body1" color={color}>
                {text}
            </Typography>
        </Box>
    );
};

export default TierIcon;
